import React, { useState, useEffect, useRef } from 'react';
import Editor from 'react-simple-wysiwyg';
import { getUserColor, getShortLetters } from '../../../utils/function';
import { UTILS } from '../../../constants';
import axios from 'axios';
// import Select2 from 'react-select2-wrapper';
// import 'select2/dist/css/select2.min.css';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { setNewComment } from '../../../redux/featuers/NewCommentSlice';

const TaggableEditor = ({ dataEditorAdded, setDataEditorAdded,cardDetail }) => {
  const [content, setContent] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const editorRef = useRef(null);
  const [Tags, setTags] = useState([]);
  const [people, setPeople] = useState([]);
  const [attachments, setAttachments] = useState([]);

  const dispatchItem = useDispatch();

  useEffect(() => {
    const filteredActivities = cardDetail?.activities?.filter(activity => activity.activity === "attached");
    const attachment = filteredActivities?.map(activity => activity.attachment?.original_name);
    setAttachments(attachment)
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const apiUrl = UTILS.API_url + `board/v1/users`;
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
            'Content-Type': 'application/json',
          },
        });
        const userNames = response?.data?.users?.map((user) => user.name) || [];
        setPeople(userNames);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();
  }, []);

  const calculateCursorPosition = () => {
    if (!editorRef.current) return;

    const selection = window.getSelection();
    if (!selection.rangeCount) return;

    const range = selection.getRangeAt(0).cloneRange();
    const rect = range.getBoundingClientRect();
    const editorRect = editorRef.current.getBoundingClientRect();

    if (rect) {
      const editorStyle = window.getComputedStyle(editorRef.current);
      const editorPaddingLeft = parseFloat(editorStyle.paddingLeft);
      const editorPaddingTop = parseFloat(editorStyle.paddingTop);

      setDropdownPosition({
        top:
          rect.bottom - editorRect.top + window.scrollY - editorPaddingTop + 5,
        left: rect.left - editorRect.left + window.scrollX - editorPaddingLeft,
      });
    }
  };

  const handleEditorChange = (e) => {
    const updatedContent = e.target.value;
    console.log('working comment---> ',updatedContent);
    setDataEditorAdded(updatedContent);

    const atSymbolIndex = updatedContent.lastIndexOf('@');

    const atSymbolIndexhash = updatedContent.lastIndexOf('#');
    if (
      atSymbolIndex !== -1 &&
      (atSymbolIndex === 0 ||
        /\s/.test(updatedContent.charAt(atSymbolIndex - 1))) &&
      /^[a-zA-Z]*$/.test(updatedContent.slice(atSymbolIndex + 1))
    ) {
      setTags("@");
      // setDropdownPosition({ top: caretRect.top, left: caretRect.left });
      calculateCursorPosition();
      setShowDropdown(true);
      setSuggestions(people);
    } else if(atSymbolIndexhash !== -1 &&
      (atSymbolIndexhash === 0 ||
        /[\s]/.test(updatedContent.charAt(atSymbolIndexhash - 1))) && // Check for space or start
      /^[a-zA-Z]*$/.test(updatedContent.slice(atSymbolIndexhash + 1)) // Check that "@" is followed by letters
      ){
        setTags("#");
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        const rect = range.getBoundingClientRect();
  
        // Calculate cursor position
        const cursorPosition = {
          top: rect.top + window.scrollY, // Adjust for page scroll
          left: rect.left + window.scrollX, // Adjust for page scroll
        };
        setDropdownPosition([cursorPosition.top, cursorPosition.left]);
        // calculateCursorPosition();
        setShowDropdown(true);
        setSuggestions(attachments); // Populate dropdown with people suggestions
    }else {
      setShowDropdown(false);
    }
  };

  
  const isRecent = (createdAt, limitInMinutes) => {
    // Check if createdAt is defined and is a string
    if (typeof createdAt !== 'string') return false;

    const currentTime = new Date();
    let timeDiffInMillis;

    if (createdAt.includes('second')) {
        const seconds = parseInt(createdAt.split(' ')[0], 10);
        timeDiffInMillis = seconds * 1000; // Convert seconds to milliseconds
    } else if (createdAt.includes('minute')) {
        const minutes = parseInt(createdAt.split(' ')[0], 10);
        timeDiffInMillis = minutes * 60 * 1000; // Convert minutes to milliseconds
    } else {
      const minutes = 50;
        timeDiffInMillis = minutes * 60 * 1000; // Convert minutes to milliseconds
        // return false; // Return false if the format isn't recognized
    }

    const createdTime = new Date(currentTime.getTime() - timeDiffInMillis);
    const differenceInMillis = currentTime - createdTime;

    return differenceInMillis > limitInMinutes * 60 * 1000; // Convert limit to milliseconds
};


  const handleSelectPerson = (person) => {
    if(Tags == "@"){
      const atSymbolIndex = dataEditorAdded.lastIndexOf('@');
      const newContent =
        dataEditorAdded.substring(0, atSymbolIndex) +
        `<span class="tag_user" contenteditable="false">@${person} newwwww</span>&nbsp;` +
        dataEditorAdded.substring(atSymbolIndex + 1);
  
      setDataEditorAdded(newContent);
      setShowDropdown(false);
    }else if(Tags == "#"){

      const foundActivity = cardDetail?.activities?.find(
        activity => activity.attachment?.original_name === person
      );
      // Get the original_name of the found activity
      const attachmentOriginalName = foundActivity?.attachment?.file_name;

      const atSymbolIndex = dataEditorAdded.lastIndexOf('#');
      const url =  isRecent(foundActivity?.attachment?.created_at , 10)
      ? UTILS.images_url + "original/" + attachmentOriginalName
      : UTILS.temp_image_url + "original/" + attachmentOriginalName;
      const newContent =
        dataEditorAdded.substring(0, atSymbolIndex) +
        `<a href="${url}"><span class="tag_user" contenteditable="false">#${person}</span></a>&nbsp;` +
        dataEditorAdded.substring(atSymbolIndex + 1);

      setDataEditorAdded(newContent);
      setShowDropdown(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Backspace' || e.key === 'Delete') {
      console.log('back space')
      const selection = window.getSelection();
      const anchorNode = selection.anchorNode;

      dispatchItem(
        setNewComment(null)
      )

      console.log("anchor---> ",anchorNode);
      if(anchorNode.parentElement.classList.contains('tag_data')){
        console.log("this need to remove/add")
      }
      if (
        anchorNode &&
        anchorNode.parentElement &&
        anchorNode.parentElement.classList.contains('tag_user')
      ) {
        const spanElement = anchorNode.parentElement;
        if (spanElement.textContent.length <= 1) {
          spanElement.remove();
        }
      }
    }
  };

  const handleSelectChange = (e) => {
    const selectedPerson = e.value;
    console.log(selectedPerson);
    handleSelectPerson(selectedPerson);
  };

  return (
    <div style={{ position: 'relative' }}>
      <Editor
        ref={editorRef}
        value={dataEditorAdded}
        onChange={handleEditorChange}
        onKeyDown={handleKeyDown}
        style={{
          minHeight: '150px',
          border: '1px solid #ddd',
          padding: '10px',
        }}
      />
      {showDropdown && (
        <Select
          options={suggestions.map((person) => ({
            value: person,
            label: person,
          }))}
          onChange={handleSelectChange}
          style={{
            position: 'absolute',
            top: dropdownPosition.top,
            left: dropdownPosition.left,
            zIndex: 1000,
            width: '200px',
          }}
          // options={{
          //   placeholder: 'Select a person...',
          //   noResultsText: 'No results found',
          //   width: '100%',
          // }}
        />
        // <Select2
        //   data={suggestions.map(person => ({ id: person, text: person }))}
        //   onSelect={handleSelectChange}
        //   style={{
        //     position: 'absolute',
        //     top: dropdownPosition.top,
        //     left: dropdownPosition.left,
        //     zIndex: 1000,
        //     width: '200px',
        //   }}
        //   options={{
        //     placeholder: 'Select a person...',
        //     noResultsText: 'No results found',
        //     width: '100%',
        //   }}
        // />
      )}
    </div>
  );
};

export default TaggableEditor;
